(function ($) {

  require('../../scss/main.scss');

  require('./header-menu');
  require('./header-search');
  require('./marker-clusterer');
  require('./map-class');
  require('./action-offers-map');
  require('./nav-tabs')(992);
  require('./write-director');
  require('./trailer-rental');
  require('./preparePostInitHookFunction');
  require('./lightbox-function');
  require('./form-init');
  require('./select-touch');


  // console.log(document.getElementById('arrival_date'));
  // window.addEventListener('resize', resize);
  //
  // function resize() {
  //
  //     if (window.innerWidth < 700) {
  //
  //         console.log('window.innerWidth < 700');
  //         // window.removeEventListener('resize', resize); // once
  //     }
  // }
  // prepinani jazykove verze
  $('.lang.active').on('click', e => {
    e.preventDefault();
  });

  // aktivni jazyk dam na prvni pozici
  $('.lang-nav ').find('active').insertBefore('li:eq(0)');

  var body = $('body'),
    isDeviceToggled,
    sideMenu = $('#aside-left.col-sm-3'),
    mainContent = $('#content-main.col-sm-9');

  $('html').attr('data-useragent', navigator.userAgent);
  body.append('<div id="action-offers-map-container"></div>');

  // IE fix na window.console object
  if (!window.console) window.console = {};
  if (!window.console.log) window.console.log = function () {};

  // kontrola, zda je ukladani do localStorage vubec mozne
  // (napr. Safari, iOS anonymni rezeim - v tom to nefunguje a formular se pote neda odeslast)
  function isLocalStorageNameSupported() {
    var testKey = 'test', storage = window.localStorage;
    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  if(!isLocalStorageNameSupported())
    $('.footer-toggle-device').remove()

  if (typeof (Storage) !== 'undefined' && isLocalStorageNameSupported()) {
    var viewport = document.querySelector('meta[name=viewport]');
    var strg = localStorage.getItem('switchMobileDesktop');
    // is mobile?
    if (detectmob()) {
      $('.footer-toggle-device').addClass('show');
      if (strg === 'desktop') {
        isDeviceToggled = true;
        viewport.setAttribute('content', 'width=1160, initial-scale=1.0');
        mainContent.before(sideMenu);
      }
      else {
        isDeviceToggled = false;
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
      }
    }
  }

  /* Funkce pro prepnuti mobilni verze na desktopovou. Je navazana na tlacitko */
  $('.footer-toggle-device a').click(function(e){
    e.preventDefault();
    var type = $(this).data('type');
    var viewport = document.querySelector('meta[name=viewport]');

    if (type === 'desktop') {
      isDeviceToggled = true;
      viewport.setAttribute('content', 'width=1160, initial-scale=1.0');
      localStorage.setItem('switchMobileDesktop', 'desktop');
      mainContent.before(sideMenu);
    } else {
      isDeviceToggled = false;
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
      localStorage.setItem('switchMobileDesktop', 'mobile');
    }
  });

  /* Funkce pro detekovani mobilniho zarizeni */
  function detectmob() {
    return ( navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i));
  }

  // Odsadenie banerov, podla toho, ci je menu rozbalene alebo zbalene
  if($('.header-menu').css('display') !== 'none')
    $('.main-banner-left, .main-banner-right').addClass('lower');

  // otevreni a vycentrovani noveho pop-up okna
  function openFormInPopUp(url, name, w, h) {
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    var width,
      height;
    width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
    var newWindow = window.open(url, name, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
  }
  $('#pojisteni-popup-form').on('click', function(e) {
    e.preventDefault();
    openFormInPopUp('http://allianz.studentagency.cz/form.php', 'formPopUpInsurance', 615, 630);
  });

  var win = $(window);
  var wind = window;

  if (!isDeviceToggled)
    swipeSideMenu();

  win.resize(function() {
    if (!isDeviceToggled)
      swipeSideMenu();

    reCountCaptchaHeight();
  })

  function swipeSideMenu() {

    var footer = $('#footer');
    var theClass = 'side-menu-moved';

    if (wind.innerWidth < 768) {
      sideMenu.addClass(theClass);
      footer.before(sideMenu);
    }
    else
    if (sideMenu.hasClass(theClass)) {
      sideMenu.removeClass(theClass);
      mainContent.before(sideMenu);
    }

  }

  // prepocita vysku captchy z duvodu ziskani presne vysky po aplikaci CSS vlastnosti transform
  var dim;
  var captcha;
  var status = true;

  var timer = setInterval(function() {
    captcha = $('#captcha');
    if ((captcha.height() > 0) && status) {
      dim = document.querySelector('#captcha').getBoundingClientRect();
      captcha.height(dim.height);
      status = false;
      clearInterval(timer);
    }
  }, 1)

  function reCountCaptchaHeight() {
    if (status)
      return false;

    captcha.css({'height' : 'auto'});
    var dimResize = document.querySelector('#captcha').getBoundingClientRect();

    if ((dimResize != dim))
      captcha.height(dimResize.height);

  }

  function contactServices() {
    // pokud neni obsah v rozeviracim bloku, odstranime vsechny sipecky naznacujici otevreni
    $('#kontakt-sluzby .pop-up-text').each(function() {
      if ($(this).find('ul li').length > 0)
        $(this).addClass('has-content');

      else {
        $(this).find('ul').hide();
        $(this).parent().find('.isopenable-hidden-mobile').hide();
      }
    })

    // fix na iPad event click
    if (navigator.userAgent.match(/iPad/i)) {
      var startWinOffset;
      $(document).on('touchstart', '.service-header-wrap', function() {
        startWinOffset = $(window).scrollTop();
      })
      $(document).on('touchend', '.service-header-wrap', function() {
        var endWinOffset = $(window).scrollTop();
        if (startWinOffset == endWinOffset)
          openContactService(this);
      })
    }
    else
      $('.service-header-wrap').on('click', function() {
        if (window.innerWidth <= 768)
          openContactService(this);
      })

  }
  function openContactService(self) {
    var popUp = $(self).next('.pop-up-text');
    if (popUp.hasClass('has-content')) {
      $(self).parent().toggleClass('clicked');
      $(self).next('.pop-up-text').stop().slideToggle(300);
    }
  }
  contactServices();

  // pro de a en verzi presmerovani
  $('.footer-menu ul li:last-child a').click(function (e) {
    var bodyClass = body.attr('class').split(' ')[0];
    if (bodyClass == 'en' || bodyClass == 'de') {
      e.preventDefault();
      if (!body.hasClass('homepage')) {
        // fix na IE (ten nema window.location.origin)
        if (!window.location.origin)
          window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port: '');

        var location = window.location.origin + '/' + bodyClass + '/' + '#form-2';
        document.location.href = (location);
      }
    }
  });

  window.countSameHeight = countSameHeight;

  function countSameHeight(elmsToBeCounted) {
    if (window.innerWidth < 768) { // od tohoto rozliseni uz to neni potreba
      elmsToBeCounted.css({'height' : 'auto'})
      return false;
    }
    var maxHeight = -1;
    // spocitani vysky elementu, nejdrive je ale musime "resetovat" nastavenim height: auto
    elmsToBeCounted.css({'height' : 'auto'}).each(function() {
      maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
    });
    // prirazeni vysky
    elmsToBeCounted.each(function() {
      $(this).height(maxHeight);
    });
  }

  // nahrazeni placeholderu pro IE9
  replacePlaceholder('is-focused', 'not-focused');

  // registrace na win pro volani v componente lightbox
  window.replacePlaceholder = replacePlaceholder;

  function replacePlaceholder(classOnFocus, classOnBlur) {
    if ($('html').is('.ie9'))

      $('form input, form textarea').each(function() {
        var self = $(this);
        var attr = self.attr('placeholder');

        if (typeof attr !== typeof undefined && attr !== false) {
          self.val(attr);

          self.on('focus', function() {
            if(self.val() == attr) {
              self.val('');
              self.addClass(classOnFocus).removeClass(classOnBlur);
            };
          }).
            on('blur', function() {
              if(self.val() == '') {
                self.val(attr);
                self.addClass(classOnBlur).removeClass(classOnFocus);
              };
            });
          self.addClass(classOnBlur);
        }
      })

  }

  // hover na iframe protoze IE to neumi normalne pres CSS
  function iframeHoverState() {

    $('.featured-service').on({
      mouseenter: function () {
        $(this).find('iframe').addClass('iframe-hover');
      },
      mouseleave: function () {
        $(this).find('iframe').removeClass('iframe-hover');
      }
    });
  }
  window.iframeHoverState = iframeHoverState;
  window.iframeHoverState();

  //Funkcionalite pre zobrazenie newletter leteniek
  $('a.letenky-newsletter-popup').click(function(e) {
    e.preventDefault();

    var opts = {
      'empty': true,
      'type': 'email',
      'message': {
        'icon': 'sa-icon icon-email'
      }
    };
    var lb = $().lightbox;
    lb.create(null, 'icon-lightbox', window.customRenderFunction, opts);
    var lbWrapper = $('.lb-main-content.lb-email');
    lbWrapper.generalForm({
      'dataPath': '/sys/bloky/form/letenky-newsletter.json',
      'scrollToForm': false,
      'noScroll': true,
      'noFormClass': true
    })
  });

  window.getUrlParameter = function(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam)
        return sParameterName[1] === undefined ? true : sParameterName[1];

    }
  };

  //Widget kontrola rezervace na letenkach

  var widget = $('.check-reservation');

  $('h4', widget).click(toggleWidget);

  $('.letenky .content').airticketOffersWidget({
    component_id: 'studentagency.cz'
  });

  function toggleWidget () {
    if ($('form', widget).is(':visible'))
      $('form', widget).slideUp();
    else
      $('form', widget).slideDown();
  }
})(jQuery);
